import React from "react";

const ReadonlyContext = React.createContext(null);

export default ReadonlyContext;
